import { __extends } from "tslib";
import { ASObject, Errors, axCoerceString } from "@awayfl/avm2";
var URLVariables = /** @class */ (function (_super) {
    __extends(URLVariables, _super);
    function URLVariables(source) {
        if (source === void 0) { source = null; }
        var _this = _super.call(this) || this;
        _this._ignoreDecodingErrors = false;
        source && _this.decode(source);
        return _this;
    }
    URLVariables.prototype.decode = function (source) {
        source = axCoerceString(source);
        var variables = source.split('&');
        for (var i = 0; i < variables.length; i++) {
            var p = variables[i];
            var j = p.indexOf('=');
            if (j < 0) {
                if (this._ignoreDecodingErrors) {
                    j = p.length;
                }
                else {
                    this.sec.throwError('Error', Errors.DecodeParamError);
                }
            }
            var name = unescape(p.substring(0, j).split('+').join(' '));
            var value = unescape(p.substring(j + 1).split('+').join(' '));
            var currentValue = this.axGetPublicProperty(name);
            if (typeof currentValue === 'undefined') {
                this.axSetPublicProperty(name, value);
            }
            else if (Array.isArray(currentValue)) {
                currentValue.push(value);
            }
            else {
                this.axSetPublicProperty(name, [currentValue, value]);
            }
        }
    };
    URLVariables.prototype.toString = function () {
        var pairs = [];
        var keys = this.axGetEnumerableKeys();
        for (var i = 0; i < keys.length; i++) {
            var name = keys[i].split(' ').join('+');
            var value = this.axGetPublicProperty(name);
            name = escape(name).split(' ').join('+');
            if (Array.isArray(value)) {
                for (var j = 0; j < value.length; j++) {
                    pairs.push(name + '=' + escape(value[j]));
                }
            }
            else {
                pairs.push(name + '=' + escape(value));
            }
        }
        return pairs.join('&');
    };
    URLVariables.classInitializer = null;
    URLVariables.classSymbols = null; // [];
    URLVariables.instanceSymbols = null;
    return URLVariables;
}(ASObject));
export { URLVariables };
